import React, { useEffect } from "react";
import { motion } from "framer-motion";
import '../assets/css/styles.css';
import { Link } from "react-router-dom";

const Career = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Hero Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Join Our <span className="breadcrumb-highlight">Team</span>
                                </h1>
                                <p className="breadcrumb-subtitle">
                                    Shape the future of technology with innovative minds at CLOUD MIND X
                                </p>
                                <button className="breadcrumb-btn">
                                    <span>VIEW OPENINGS</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Why Join Us Section */}
            <section className="career-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <motion.h2
                                className="section-title"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                Why Join <span className="highlight">CLOUD MIND X?</span>
                            </motion.h2>
                            <motion.p
                                className="section-subtitle"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                Be part of a dynamic team that's revolutionizing the tech industry
                            </motion.p>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-lg-4 col-md-6 mb-4">
                            <motion.div
                                className="career-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <div className="career-icon">
                                    <i className="fa fa-rocket" style={{ color: '#fff' }}></i>
                                </div>
                                <h4>Innovation</h4>
                                <p>Work on cutting-edge technologies and innovative solutions that shape the future.</p>
                            </motion.div>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <motion.div
                                className="career-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                <div className="career-icon">
                                    <i className="fa fa-users" style={{ color: '#fff' }}></i>
                                </div>
                                <h4>Team Collaboration</h4>
                                <p>Join a diverse team of experts who value collaboration and knowledge sharing.</p>
                            </motion.div>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <motion.div
                                className="career-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                            >
                                <div className="career-icon">
                                    <i className="fa fa-trophy" style={{ color: '#fff' }}></i>
                                </div>
                                <h4>Growth Opportunities</h4>
                                <p>Continuous learning and career development with global exposure.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Current Openings Section */}
            <section className="openings-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <motion.h2
                                className="section-title"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                Current <span className="highlight">Openings</span>
                            </motion.h2>
                            <motion.p
                                className="section-subtitle"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                Explore exciting career opportunities with us
                            </motion.p>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-lg-6 mb-4">
                            <motion.div
                                className="opening-card"
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                <div className="opening-header">
                                    <h4>Senior AI Engineer</h4>
                                    <span className="location">Dubai, UAE</span>
                                </div>
                                <p style={{ textAlign: 'left' }}>Design and develop AI-powered solutions for enterprise clients.</p>
                                <div className="opening-tags">
                                    <span>Python</span>
                                    <span>Machine Learning</span>
                                    <span>TensorFlow</span>
                                </div>
                                <button className="apply-btn">Apply Now</button>
                            </motion.div>
                        </div>

                        <div className="col-lg-6 mb-4">
                            <motion.div
                                className="opening-card"
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <div className="opening-header">
                                    <h4>Full Stack Developer</h4>
                                    <span className="location">Dubai, UAE</span>
                                </div>
                                <p style={{ textAlign: 'left' }}>Build scalable web applications using modern technologies.</p>
                                <div className="opening-tags">
                                    <span>React</span>
                                    <span>Node.js</span>
                                    <span>MongoDB</span>
                                </div>
                                <button className="apply-btn">Apply Now</button>
                            </motion.div>
                        </div>

                        <div className="col-lg-6 mb-4">
                            <motion.div
                                className="opening-card"
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                <div className="opening-header">
                                    <h4>Cloud Architect</h4>
                                    <span className="location">Dubai, UAE</span>
                                </div>
                                <p style={{ textAlign: 'left' }}>Design and implement cloud infrastructure solutions.</p>
                                <div className="opening-tags">
                                    <span>AWS</span>
                                    <span>Azure</span>
                                    <span>Docker</span>
                                </div>
                                <button className="apply-btn">Apply Now</button>
                            </motion.div>
                        </div>

                        <div className="col-lg-6 mb-4">
                            <motion.div
                                className="opening-card"
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                            >
                                <div className="opening-header">
                                    <h4>Cybersecurity Specialist</h4>
                                    <span className="location">Dubai, UAE</span>
                                </div>
                                <p style={{ textAlign: 'left' }}>Protect our clients from cyber threats and vulnerabilities.</p>
                                <div className="opening-tags">
                                    <span>Security</span>
                                    <span>Penetration Testing</span>
                                    <span>Risk Assessment</span>
                                </div>
                                <button className="apply-btn">Apply Now</button>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Company Culture Section */}
            <section className="culture-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                <h2 className="section-title">Our <span className="highlight">Culture</span></h2>
                                <p className="culture-text">
                                    At CLOUD MIND X, we foster a culture of innovation, collaboration, and continuous learning.
                                    Our diverse team brings together talented individuals from around the world who are
                                    passionate about technology and making a positive impact.
                                </p>
                                <ul className="culture-list">
                                    <li><i className="fa fa-check"></i> Flexible working hours</li>
                                    <li><i className="fa fa-check"></i> Professional development opportunities</li>
                                    <li><i className="fa fa-check"></i> Competitive salary and benefits</li>
                                    <li><i className="fa fa-check"></i> Work-life balance</li>
                                    <li><i className="fa fa-check"></i> International exposure</li>
                                </ul>
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.div
                                className="culture-image"
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                <img src={require('../assets/images/team-culture.avif')} alt="Team Culture" />
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="career-contact-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center" style={{ textAlign: 'center' }}>
                            <motion.h2
                                className="section-title"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}

                                style={{ textAlign: 'center' }}
                            >
                                Ready to Join Our <span className="highlight">Team?</span>
                            </motion.h2>
                            <motion.p
                                className="section-subtitle"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                                style={{ textAlign: 'center' }}
                            >
                                Send us your resume and let's discuss how you can contribute to our mission.
                            </motion.p>
                            <Link to="/contact">
                                <motion.button
                                    className="contact-btn"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: 0.4 }}
                                >
                                    Get In Touch
                                </motion.button>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Career;
